import confirmItemActionAllowed from '../utils/confirmItemActionAllowed';
import { ClientItemId } from 'owa-client-ids';
import { lazyReplyToMessage } from 'owa-mail-compose-store';
import * as mailModuleOrchestrator from 'owa-mail-module-orchestrator';
import { InstrumentationContext, mailStore } from 'owa-mail-store';
import IRMRestrictions from 'owa-mail-store/lib/store/schema/IRMRestrictions';
import Item from 'owa-service/lib/contract/Item';
import { lazyAllowResponseForSmimeItem } from 'owa-smime';
import isSMIMEItem from 'owa-smime/lib/utils/isSMIMEItem';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';
import { action } from 'satcheljs/lib/legacy';
import { ActionSource } from 'owa-analytics-actions';

export default action('replyToItem')(async function replyToItem(
    itemId: ClientItemId,
    isReplyAll: boolean,
    instrumentationContexts: InstrumentationContext[],
    actionSource: ActionSource,
    suppressServerMarkReadOnReplyOrForward: boolean
) {
    const restrictionToConfirm = <IRMRestrictions>{
        ReplyAllAllowed: isReplyAll,
        ReplyAllowed: !isReplyAll,
    };
    const itemActionString = isReplyAll ? strings.itemHeaderReplyAll : strings.itemHeaderReply;
    const item: Item = mailStore.items.get(itemId.Id);
    const isResponseAllowedForSmimeItem =
        !isSMIMEItem(item) ||
        (await (await lazyAllowResponseForSmimeItem.import())(itemId.Id, itemActionString));

    if (
        confirmItemActionAllowed(
            itemId.Id,
            restrictionToConfirm,
            format(strings.irm_actionNotAllowedOnThisItem, itemActionString)
        ) &&
        isResponseAllowedForSmimeItem
    ) {
        lazyReplyToMessage.importAndExecute({
            referenceItemId: itemId,
            isReplyAll: isReplyAll,
            useFullCompose: true,
            actionSource: actionSource,
            instrumentationContexts: instrumentationContexts,
            suppressServerMarkReadOnReplyOrForward: suppressServerMarkReadOnReplyOrForward,
        });

        mailModuleOrchestrator.lazyOnReplyOrReplyAllOrForwardMessage.importAndExecute();
    }
});
